import { render } from "./MyWebsites.vue?vue&type=template&id=511ca212&scoped=true"
import script from "./MyWebsites.vue?vue&type=script&lang=js"
export * from "./MyWebsites.vue?vue&type=script&lang=js"

import "./MyWebsites.vue?vue&type=style&index=0&id=511ca212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511ca212"]])

export default __exports__